import {
    tss,
} from 'app/tss'

export default tss
    .create(({
        theme,
    }) => {
        return {
            detailsViewContainer: {
                position: 'relative',
                padding: theme.spacing(1),
                backgroundColor: theme.palette.secondary[50],
                minHeight: 400,
            },
            actionFormContainer: {
                position: 'relative',
                zIndex: 1,
                padding: theme.spacing(1),
                backgroundColor: theme.palette.secondary[50],
                marginBottom: theme.spacing(2),
            },
            expandableDataGridOverwrites: {
                '& .MuiDataGrid-virtualScrollerRenderZone': {
                    transform: 'none !important',
                },
                '& .MuiDataGrid-root': {
                    transform: 'none !important',
                },
            },
        }
    })
